import React, { useEffect, createContext, useContext } from 'react'
import '../styles/global.css'
import '../styles/typography.css'
import { observer } from 'mobx-react-lite'

import rootStore from '../stores/store'

import { TransitionPageWrap } from '../components/General/Transition'
import debounce from 'lodash/debounce'

export const localizedSectionContext = createContext(true)
export const richTextContext = createContext(true)

export const storeContext = createContext(rootStore)

export const useStore = () => useContext(storeContext)

const StoreProvider = observer(({ children }) => {
	// const store = useLocalStore(storeContext); WTF!? never works - https://mobx-react.js.org/recipes-context
	const store = useStore()
	const {
		uiStore: {
			updateWindowHeight,
			updateWindowWidth,
			updateScrollPosition,
			article__modalActive,
			getPageHeight
		},
	} = store

	const handleResize = () => {
		updateWindowWidth(window.innerWidth)
		updateWindowHeight(window.innerHeight)
		getPageHeight()
		// rootStore.uiStore.getPageHeight()

	}

	// const listenToScroll = () => {
	// 	// const winScroll =
	// 	// 	document.body.scrollTop || document.documentElement.scrollTop

	// 	// const height =
	// 	// 	document.documentElement.scrollHeight -
	// 	// 	document.documentElement.clientHeight

	// 	// const scrolled = winScroll / height
	// 	// updateScrollPosition(scrolled)
	// 	// updateScrollPositionTotal(winScroll)

	// 	updateScrollPosition();
	// }

	useEffect(() => {
		window.addEventListener('resize', debounce(handleResize, 300), false)
		window.addEventListener('scroll', updateScrollPosition);

		return () => {
			window.removeEventListener('resize', debounce(handleResize, 300), false)
			window.removeEventListener('scroll', updateScrollPosition)
		}
	}, [])

	// When modal open prevent scroll underneath
	useEffect(() => {
		document.getElementsByTagName(
			'html'
		)[0].style.overflow = article__modalActive ? 'hidden' : 'scroll'
	}, [article__modalActive])

	return <storeContext.Provider value={store}>{children}</storeContext.Provider>
})

export const PageProvider = ({ element, props }) => (
	// <Layout {...props}>{element}</Layout>
	<TransitionPageWrap {...props}>{element}</TransitionPageWrap>
)

export default ({ element }) => {
	return (
		<StoreProvider>
			{element}
		</StoreProvider>
	)
}
